import React, { useState, useContext } from "react";

import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext"
import DemoRq from "../components/demorequest";
import WebHeaderLogin from "../components/web_header_login";



function Hardware() {

    const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones

    return (
        <>
<div class="body">
<WebHeaderLogin/>
<h2>{t('hardwareT1')}</h2> 
<p className="text2"> {t('hardwareT2')} </p>

<div >

<table className="table2">
  <thead>
    <tr>
      <th className="col1">{t('hardwareE0T0')} </th>
      <th className="col2">{t('hardwareE0T1')} </th>
      <th className="col3">{t('hardwareE0T2')} </th>

    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="col1"><img class="image5" src= "https://storage.googleapis.com/tt202501/images/Techtalamo_Hd1.png" ></img></td>
      <td className="col2">{t('hardwareE1T1')}</td>
      <td className="col3">{t('hardwareE1T2')}</td>
    </tr>
    <tr>
      <td className="col1"><img class="image5" src= "https://storage.googleapis.com/tt202501/images/Techtalamo_Hd2.png" ></img></td>
      <td className="col2">{t('hardwareE2T1')}</td>
      <td className="col3">{t('hardwareE2T2')}</td>
    </tr>
    <tr>
      <td className="col1"><img class="image5" src= "https://storage.googleapis.com/tt202501/images/Techtalamo_Hd3.png" ></img></td>
      <td className="col2">{t('hardwareE3T1')}</td>
      <td className="col3">{t('hardwareE3T2')}</td>
    </tr>
    <tr>
      <td className="col1"><img class="image5" src= "https://storage.googleapis.com/tt202501/images/Techtalamo_Hd4.png" ></img></td>
      <td className="col2">{t('hardwareE4T1')}</td>
      <td className="col3">{t('hardwareE4T2')}</td>
    </tr>
    <tr>
      <td className="col1"><img class="image5" src= "https://storage.googleapis.com/tt202501/images/Techtalamo_Hd5.png" ></img></td>
      <td className="col2">{t('hardwareE5T1')}</td>
      <td className="col3">{t('hardwareE5T2')}</td>
    </tr>

  </tbody>
</table>

</div>

       

</div>
        </>
    );
}

export default Hardware;
